var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"login__content"},[_c('LogosContainer',{attrs:{"center":""}}),_c('div',{staticClass:"login__text"},[_c('span',{staticClass:"fa fa-spinner fa-spin"}),_vm._v("\n            "+_vm._s(_vm.$t("Accessing, please wait"))+"...\n        ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }